module.exports = __webpack_public_path__ + "assets/img/warrior-name-b891ab52.png";